/**
 * TanStack Query hooks for `soc-2-iso-27001-attested`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	soc2Iso27001AttestedQueryKeys,
	type CreateSoc2Iso27001AttestedBody,
	type ListSoc2Iso27001AttestedResponse,
	type Soc2Iso27001AttestedRow,
} from "./api";

export function useSoc2Iso27001AttestedList(): UseQueryResult<ListSoc2Iso27001AttestedResponse, Error> {
	return useQuery({
		queryKey: soc2Iso27001AttestedQueryKeys.list(),
		queryFn: list,
	});
}

export function useSoc2Iso27001AttestedCreate(): UseMutationResult<Soc2Iso27001AttestedRow, Error, CreateSoc2Iso27001AttestedBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: soc2Iso27001AttestedQueryKeys.all });
		},
	});
}

export function useSoc2Iso27001AttestedDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: soc2Iso27001AttestedQueryKeys.all });
		},
	});
}
